import type { Entitlement } from '@ctct/domain-layer';
import { ADD_ON_IDS } from '@ctct/domain-layer';
import type { CancelAddOnSubscriptionMutation } from '@ctct/state-server-layer';

export class CancelSMSAddOnService {
  private readonly CANCEL_REASON_ID_FOR_UNUSED_ADDON = 29;

  constructor(
    private SMSEntitlement: Entitlement,
    private cancelAddOnSubscriptionMutation: CancelAddOnSubscriptionMutation,
    private isSingleBillChildAccount: boolean
  ) {}

  public api() {
    return {
      isSMSaddOnNotUsed: () => this.SMSEntitlement.getIsNotUsed(),
      cancelSMSAddOn: async () => {
        if (this.isSingleBillChildAccount) {
          return;
        }

        await this.cancelAddOnSubscriptionMutation.mutateAsync({
          addOnBaasId: ADD_ON_IDS.SMS,
          cancelReasonId: this.CANCEL_REASON_ID_FOR_UNUSED_ADDON,
        });
      },
    };
  }

  public data() {
    return {};
  }

  public handlers() {
    return {};
  }
}
